export default "__VITE_ASSET__$TicdmKa__"